module.exports = __webpack_public_path__ + "static/img/icon-house-top.6fce6b0.png";